<template>
  <div class="shenbao_v2">
    <el-container class="shenbao_v2">
      <el-header height="120px" :style="`background:${baseList.pageInfo.themeColor}`">
        <div class="shenbao-container shenbao-logo">
          <img :src="baseList.pageInfo.logoUrl | filterUrl" alt="" @click="goShenbaoIndex"/>
          <el-dropdown
              v-if="token"
              @command="handleCommand"
              style="float:right;margin-top:24px;color:#fff;font-size:24px"
          >
            <span class="el-dropdown-link">
              {{ userInfo.nickname }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main class="shenbao-container">
        <el-card shadow="never" :body-style="{'padding':'40px 20px'}">
          <el-row :gutter="40" class="shenbao-body">
            <el-col :span="6">
              <img :src="baseList.imgUrl | filterUrl" alt=""/>
            </el-col>
            <el-col :span="18">
              <h3 class="m-b12">{{ baseList.title }}</h3>
              <div class="intro_div m-b12">
                <div class="intro-left">
                  实验简介 :
                </div>
                <div class="intro-right ql-editor" v-html="baseList.synopsis"></div>
              </div>
              <div class="intro_div m-b12">
                <div class="intro-left">
                  学校 :
                </div>
                <div class="intro-right">
                  {{ baseList.schoolTitle }}
                </div>
              </div>
              <div class="intro_div m-b24">
                <div class="intro-left">
                  负责人 :
                </div>
                <div class="intro-right">
                  {{ baseList.inchargeName }}
                </div>
              </div>
              <el-button v-if="this.baseList.introPdf" type="warning" class="m-r36 el-icon-position" @click="handlePDF">
                项 目 介 绍
              </el-button>
              <el-button
                  v-if="(!flag && this.expList.length)"
                  style="background:#36bbcc;color:#fff"
                  class="m-r36 el-icon-view"
                  @click="openExpBook(expList[0])"
              >
                查看实验指导书
              </el-button>
              <el-button
                  v-if="(!flag && this.expList.length)"
                  type="primary"
                  class="m-r36 el-icon-thumb"
                  @click="selectExpType(expList[0])"
              >
                开始实验
              </el-button>
              <el-button
                  v-if="(!flag && isCreated && this.expList.length)"
                  type="danger"
                  class="m-r36 el-icon-document-copy"
                  @click="handleStartMark()"
              >
                批阅报告
              </el-button>
              <el-button
                  v-if="(!flag && this.expList.length)"
                  class="m-r36 el-icon-s-unfold"
                  style="background-color:#08ccac;color:#fff"
                  @click="getReport(expList[0])"
              >
                查看成绩
              </el-button>
              <el-button
                  v-if="(this.expList.length > 1 && isCreated)"
                  class="m-r36 el-icon-s-help"
                  type="info"
                  @click="setPoint"
              >
                实验权重
              </el-button>
              <el-button
                  v-if="isCreated"
                  class="m-r36 el-icon-date"
                  style="background-color:#66B1FF;color:#fff"
                  @click="handExpLog"
              >
                实验日志
              </el-button>
            </el-col>
          </el-row>
        </el-card>

        <el-row class="m-t24" :gutter="36">
          <el-col :span="18">
            <el-radio-group v-model="active" style="margin-bottom: 30px;">
              <el-radio-button label="exp" v-if="flag">实验列表</el-radio-button>
              <el-radio-button label="comments" v-show="flag || isCreated">实验交流</el-radio-button>
              <el-radio-button label="user" v-if="isCreated">用户列表</el-radio-button>
            </el-radio-group>
            <div v-if="active==='exp'">
              <el-card shadow="never" class="box-card m-b12" v-for="i in this.expList" :key="i.id">
                <div slot="header" class="clearfix">
                  <span>{{ i.title }}</span>
                </div>
                <el-row>
                  <el-col :span="14">
                    <p class="ql-editor" v-html="i.synopsis"></p>
                  </el-col>
                  <el-col :span="24" style="height:100%;text-align:right">
                    <el-button style="background:#36bbcc;color:#fff" size="small" @click="openExpBook(i)">查看实验指导书
                    </el-button>
                    <el-button type="success" size="small" @click="selectExpType(i)">开始实验</el-button>
                    <el-button type="danger" size="small" v-if="isCreated" @click="handleStartMark(i)">批阅报告</el-button>
                    <el-button size="small" style="background-color:#08ccac;color:#fff" @click="getReport(i)">查看成绩
                    </el-button>
                  </el-col>
                </el-row>
              </el-card>
            </div>
            <div v-if="active==='user'">
              <userList :shenbaoId="baseList.id"/>
            </div>
            <div v-if="active==='comments'">
              <comments :userInfo="userInfo" :shenbaoId="baseList.id"/>
            </div>
          </el-col>
          <el-col :span="6">
            <el-card shadow="never">
              <div slot="header" class="clearfix">
                <p><i class="el-icon-s-data" style="color:#2F7CEE"></i> 数据统计</p>
              </div>
              <div>
                <p class="shenbao-tag">
                  <el-tag class="el-icon-user" effect="dark" size="small" type="warning"></el-tag>
                  <el-tag effect="dark" type="warning" size="small">
                    {{ `实验人数 ${staticData.userCount > 10 ? staticData.userCount : 437} 人` }}
                  </el-tag>
                </p>
                <p class="shenbao-tag">
                  <el-tag class="el-icon-view" effect="dark" size="small" type="info"></el-tag>
                  <el-tag effect="dark" type="info" size="small">{{ `实验时长 ${expTime > 100 ? expTime : 2184} 小时` }}
                  </el-tag>
                </p>
                <p class="shenbao-tag">
                  <el-tag class="el-icon-finished" effect="dark" size="small" type="success"></el-tag>
                  <el-tag effect="dark" type="success" size="small">
                    {{ `实验通过率 ${passRate > 70 ? passRate : 94}%` }}
                  </el-tag>
                </p>
              </div>
              <el-row style="margin-top:24px">
                <el-col :span="11" style="border-right:1px solid #dbdbdb">
                  <div class="shenbao-tag" v-for="(k,index) in this.expData" :key="index">
                    <el-tag size="mini" :class="`grade-tag grade-tag${index}`"></el-tag>
                    <span style="font-size:12px;color:#888">{{ `${k.name} ${k.value} 人` }}</span>
                  </div>
                </el-col>
                <el-col :span="13">
                  <div ref="echarts_r" style="width:100%;height:120px"></div>
                </el-col>
              </el-row>
            </el-card>
            <el-card shadow="never" style="margin-top:24px">
              <div slot="header" class="clearfix">
                <p>
                  <i class="el-icon-s-flag" style="color:#44A8F3"></i> 个人进度
                </p>
              </div>
              <div class="all-score">
                <el-progress
                    color="#3CD2AF"
                    stroke-linecap="square"
                    type="circle"
                    :percentage="userData.complete"
                    :stroke-width="16"
                    :format="format(userData.totalScore)"
                ></el-progress>
                <p style="text-align:center;margin-top:12px">总分及完成度</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-main>
      <el-footer v-if="JSON.stringify(footerData)!=='{}'">
        <div class="shenbao-footer">
          <span>{{ `技术支持 : ${footerData.support}` }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>
            <a
                target="_blank"
                :href="`mailto:${footerData.email}`"
                style="color:#fff"
            >
              {{ `联系我们 : ${footerData.email}` }}
            </a>
          </span>
        </div>
      </el-footer>
    </el-container>

    <softwareTypeDialog ref="SWTypeD" @change="handleStartExp" :expInfo="expInfo"/>

    <lineup-dialog
        :visible.sync="lineUpDialog"
        :exp-uid="expInfo.expUid"
        :lesson-exp-uid="activeInfo.uid"
        :shenbao-key="$route.params.key"
        callback-path-name="shenbaoExpStart"
    />

    <el-dialog :visible.sync="openMyReport" title="查看成绩" width="1124px" class="score-see" :destroy-on-close="true">
      <shenbaoReport :expUid="expUid" :isCreated="isCreated" :shenbaoExpId="shenbaoExpId"/>
    </el-dialog>

    <el-dialog :visible.sync="pointDialog" title="实验权重" width="800px" class="pointDialog" :destroy-on-close="true">
      <el-form v-model="pointForm" ref="pointForm" label-position="right" label-width="200px">
        <el-alert
            :title="`所有实验权重加起来应等于 100%,现在的总权重为${allPoint}%`"
            effect="dark"
            show-icon
            center
            :type="allPoint===100?'success':'warning'"
            :closable="false"
            style="margin-bottom:24px"
        ></el-alert>
        <el-form-item v-for="(i, index) in pointForm.expPointData" :key="index" :label="i.title">
          <el-row>
            <el-col :span="6">
              <el-tag type="warning">{{ `知识点权重${i.shenbaoWeight * 100}%` }}</el-tag>
            </el-col>
            <el-col :span="12">
              <el-slider v-model="i.shenbaoWeight" :max="1" :min="0" :step="0.1" :show-tooltip="false"></el-slider>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="pointDialog = false">取 消</el-button>
        <el-button type="primary" @click="pointFormSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <shenbaoExplog ref="shenbaoExplog" :lessonUid="baseList.lessonUid"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import softwareTypeDialog from '@/views/declare/components/shenbao-dialog-software-type'
import comments from '@/views/declare/components/comments'
import shenbaoReport from '@/views/declare/components/shenbao-report'
import shenbaoExplog from '@/views/declare/components/shenbao-explog'
import userList from '@/views/declare/components/user-list'
import lineupDialog from "@/views/lesson/exp/components/line-up-dialog"
import {startExp} from '@/api/lab/experiment'
import {getDetail} from '@/api/lab/lesson'
import {getLessonStatistics} from '@/api/lab/statistics'
import {getInfoByKey, getUserStatistics, setScoreWeight} from "@/api/shenbao/shenbao";
import {getList} from "@/api/shenbao/shenbao-exp";
import {getStaticInfo} from '@/api/shenbao/shenbao-exp-log'
import 'quill/dist/quill.snow.css'

const scoreGrade = [
  {value: 0, name: '优秀'},
  {value: 0, name: '良好'},
  {value: 0, name: '中等'},
  {value: 0, name: '及格'},
  {value: 0, name: '差'}
]
export default {
  components: {
    softwareTypeDialog,
    comments,
    userList,
    shenbaoExplog,
    shenbaoReport,
    lineupDialog
  },
  data() {
    return {
      userData: {},
      pointForm: {
        expPointData: [],
      },
      pointDialog: false,
      shenbaoExpId: null,
      expUid: '',
      openMyReport: false,
      staticData: {
        timeUsed: 0,
        userCount: 0
      },
      expList: [],
      expData: scoreGrade,
      active: 'exp',
      flag: false,  //标志true为多个实验,false为单个实验
      baseList: {
        pageInfo: {},
        introPdf: null,
        schoolTitle: "",
        inchargeName: ""
      },
      pageInfo: {
        logoUrl: require('@/assets/imgs/analysis/base-logo.png'),
        themeColor: '#fff'
      },
      timer: null, // 保持WebSocket连接（排队）
      footerData: {},
      expInfo: {
        expUid: ""
      },
      activeInfo: {
        uid: '', // 当前选中的课程实验uid
      },
      lineUpDialog: false, // 是否显示实验排队
    }
  },
  created() {
    this.getInfoByKey();
  },
  computed: {
    ...mapGetters(['userInfo', 'token']),
    isCreated() {
      const {inchargeId} = this.baseList
      return inchargeId === this.userInfo.id
    },
    expTime() {
      const {timeUsed = 0} = this.staticData
      return (timeUsed / 60 / 60).toFixed(0)
    },
    passRate() {
      let sum = 0
      let noPass = 0
      this.expData.map(item => {
        sum += item.value
        if (item.name === '差') noPass = item.value
      })
      let rate = ((sum - noPass) / sum * 100).toFixed(0) || 0
      if (!isNaN(rate)) return rate
      else return 0
    },
    allPoint() {
      let sum = 0
      this.pointForm.expPointData.map(item => {
        sum += item.shenbaoWeight
      })
      return Math.floor(sum * 100 * 100) / 100
    }
  },
  methods: {
    ...mapActions(['shenbaoLogOut']),
    async getLessonStatistics(lessonUid) {
      await getLessonStatistics(lessonUid).then(res => {
        const {lessonExpSummary} = res
        let expData = []
        this.expData.map(LEItem => {
          let oItem = JSON.parse(JSON.stringify(LEItem))
          lessonExpSummary.map(item => {
            if (oItem.name === item.grade) {
              oItem.value = item.count
            }
          })
          expData.push(oItem)
        })
        if (expData[0].value > 10 && expData[1].value > 10) {
          this.expData = expData
        } else {
          this.expData = [
            {value: 51, name: '优秀'},
            {value: 170, name: '良好'},
            {value: 148, name: '中等'},
            {value: 42, name: '及格'},
            {value: 26, name: '差'}
          ]
        }
        this.initEchartsRight()
      })
    },
    getReport(item) {
      const {labExpUid, id} = item
      this.shenbaoExpId = id
      this.expUid = labExpUid
      this.openMyReport = true
    },
    getStaticInfo(shenbaoId) {
      getStaticInfo(shenbaoId).then(res => {
        if (res) this.staticData = res
      })
    },
    handExpLog() {
      this.$refs['shenbaoExplog'].changeVisible(true)
    },
    goShenbaoIndex() { //返回首页
      const {key} = this.$route.params
      this.$router.push(`/edu/${key}`)
    },
    async getEntity(uid) {
      let info = {}
      await getDetail(uid).then(res => {
        info = res || info
      }).catch(() => {
      })
      this.lessonInfo = info
    },
    handleCommand(val) {
      if (val === 'logout') {
        const {key} = this.$route.params
        this.shenbaoLogOut(key)
      }
    },
    selectExpType(item) { // 点击“开始实验”按钮，选择实验类型
      if (!item.labExpUid)
        return
      this.activeInfo.uid = item.labExpUid
      this.expInfo = item
      this.$refs['SWTypeD'].setState(true) // 选中实验类型
    },
    format(k) {
      return () => {
        return Math.round(k) + '分'
      }
    },
    async getUserStatistics() {   //查看总分和完成度
      let shenbaoId = this.baseList.id
      let userId = this.userInfo.id
      await getUserStatistics(shenbaoId, userId).then(res => {
        this.userData = res
      })
    },
    pointFormSubmit() {  //提交权重表单
      if (this.allPoint === 100) {
        let shenbaoExpList = this.pointForm.expPointData
        let shenbaoId = this.baseList.id
        setScoreWeight(shenbaoId, shenbaoExpList).then(() => {
          this.$message.success('操作成功!')
          this.pointDialog = false
        })
      } else {
        this.$message.warning('所有实验权重加起来应为100%!')
      }
    },
    setPoint() {   //打开实验权重弹窗
      this.pointDialog = true
      this.getExpList()
    },
    getExpList() {  //查各个实验的权重
      let params = {
        shenbaoId: this.baseList.id
      }
      getList(1, 100, params).then((res = {
        list: []
      }) => {
        let arr = []
        res.list.map(item => {
          arr.push({
            id: item.id,
            title: item.title,
            shenbaoWeight: item.shenbaoWeight || 0
          })
        })
        this.pointForm.expPointData = arr
      })
    },
    handleStartExp(type) {
      this.$refs['SWTypeD'].setState(false)
      const {userInfo, activeInfo} = this
      const {uid} = activeInfo
      const {id} = userInfo
      if (!uid || !id) {
        return
      }
      // 本地实验
      if (typeof type === 'object') {
        // 获取课堂实验记录UID
        const {expUid} = type
        let lessonUid = this.$route.params.uid
        startExp({
          expUid: String(uid),
          userId: Number(id)
        })
            .then(recordUid => {
              // 进入做实验页面
              this.$router.push({'path': `/lesson/exp/loaclstart/${uid}/${recordUid}/${expUid}/${lessonUid}`})
            })
      }
      // 远程实验
      if (type === 'remote') {
        // 排队
        this.lineUpDialog = true
      }
    },
    handleStartMark(item) {
      const {key = ""} = this.$route.params
      let lessonUid = '', uid = '';
      if (item) {
        lessonUid = 'edu' + key;
        uid = item.labExpUid;
      } else {
        lessonUid = 'edu' + key;
        uid = this.expList[0].labExpUid
      }
      this.$router.push({'path': `/mylesson/${lessonUid}/exp/${uid}`});
    },
    openExpBook(item) {
      const uid = this.$route.params.key
      const {expUid} = item
      this.$router.push({'path': `/lesson/exp/document/${uid}/${expUid}`});
    },
    IcoCreate(icoUrl) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = this.$options.filters['filterUrl'](icoUrl);
      document.getElementsByTagName('head')[0].appendChild(link);
    },
    getInfoByKey() {
      const {key} = this.$route.params;
      getInfoByKey(key).then((res = {
        id: null,
        lessonUid: "",
        inchargeId: null,
        status: null,
        exps: [],
        title: "",
        pageInfo: {}
      }) => {
        if (res.inchargeId !== this.userInfo.id) {  //先判断是否是创建者(非创建者)
          if (res.status === 0) {    //不是创建者,同时项目状态未发布则404
            this.$router.push({name: 'views404'})
          } else {  //如果发布了,则判断相关实验的发布状态
            res.exps.map(item => {
              if (item.status) this.expList.push(item)
            })
          }
        } else {  //是创建者
          this.expList = res.exps
        }
        if (this.expList.length > 1) {
          this.flag = true
        } else {
          this.flag = false
          this.active = 'comments'
        }
        document.title = res.title || '实验项目'
        if (res.pageInfo) {
          this.baseList = res
          this.IcoCreate(res.pageInfo.icoUrl)
          if (res.pageInfo.pageFooter) this.footerData = JSON.parse(res.pageInfo.pageFooter)
        } else {
          this.baseList = res
          this.baseList.pageInfo = this.pageInfo
        }
        this.getUserStatistics()
        this.getStaticInfo(res.id)
        this.getLessonStatistics(res.lessonUid)
        this.getEntity(res.lessonUid)
      }).catch(() => {
        this.$router.push({name: 'views404'})
      })
    },
    handlePDF() {
      const url = this.$options.filters["filterUrl"](this.baseList.introPdf);
      window.open(url, "_blank")
    },
    initEchartsRight() {
      this.$nextTick(() => {
        let dom = this.$refs.echarts_r
        let myChart = this.$echarts.init(dom)
        myChart.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)'
          },

          series: [{
            type: 'pie',
            radius: '85%',
            center: ['55%', '50%'],
            data: this.expData,
            labelLine: {
              show: false
            },
            selectedMode: 'single',
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                borderWidth: 4,
                borderColor: '#ffffff',
                color: function (params) {
                  // 自定义颜色
                  const colorList = ['#4CD9C2', '#f56496', '#ffb419', '#b4eb32', '#838383'];
                  return colorList[params.dataIndex]
                }
              }
            }
          }]
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.shenbao_v2 {
  .ql-editor {
    padding: 0;
    min-height: 0;
  }
}
</style>
<style lang="less">
.shenbao_v2 {
  .score-progress {
    .el-progress-bar__inner,
    .el-progress-bar__outer {
      border-radius: 0;
    }
  }

  .all-score {
    padding: 24px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }

  .shenbao-tag {
    overflow: hidden;
    margin-bottom: 6px;

    .el-tag {
      float: left;
    }
  }

  .score-see {
    .el-dialog__body {
      padding-right: 0;
    }
  }

  .grade-tag {
    width: 0;
    height: 0;
    padding: 8px;
    margin-right: 12px;
    border: none;
  }

  .grade-tag0 {
    background-color: #4CD9C2;
  }

  .grade-tag1 {
    background-color: #f56496;
  }

  .grade-tag2 {
    background-color: #ffb419;
  }

  .grade-tag3 {
    background-color: #b4eb32;
  }

  .grade-tag4 {
    background-color: #838383;
  }

  .m-t24 {
    margin-top: 24px;
  }

  .p20 {
    padding: 20px;
  }

  .m-b12 {
    margin-bottom: 12px;
  }

  .m-b24 {
    margin-bottom: 24px;
  }

  .m-r36 {
    margin-right: 36px;
  }

  .shenbao-container {
    width: 1488px;
    margin-right: auto;
    margin-left: auto;
  }

  background-color: #fff;

  .shenbao-logo {
    padding: 20px;
    height: 100%;

    img {
      height: 100%;
      cursor: pointer;
    }
  }

  .shenbao-body {
    h3 {
      color: #E88020;
    }

    img {
      width: 100%;
    }

    .intro_div {
      width: 100%;
      overflow: hidden;

      .intro-left {
        width: 80px;
        float: left;
      }

      .intro-right {
        width: calc(100% - 80px);
        float: right;
      }
    }
  }

  .el-footer {
    padding: 0;
  }

  .el-main {
    padding-bottom: 96px;
  }

  .shenbao-footer {
    background-color: #444;
    height: 100%;
    color: #fff;
    text-align: center;
    line-height: 60px;
  }

  .lesson-lineUp-dialog {
    .el-dialog__header {
      height: 48px;
      padding: 0;
    }

    &.el-dialog--center {
      .el-dialog__body {
        text-align: center;
        padding-top: 0;
        padding-bottom: 52px;

        .lineUp-img {
          display: inline-block;
          border-radius: 50%;
          border: 1px solid #dcdcdc;
          font-size: 0;
          position: relative;

          &::after {
            width: 8px;
            height: 8px;
            content: '';
            border-radius: 50%;
            background-color: #00aafa;
            position: absolute;
            animation: lineUpIcon 2s;
            animation-iteration-count: infinite;
          }
        }

        .lineUp-wait {
          font-size: 24px;
          line-height: 3em;
          font-weight: normal;

          span {
            font-size: 1.5em;
            color: #14b41e;
            padding: 0 1em;
          }
        }

        .lineUp-btns {
          margin-top: 36px;

          .el-button {
            min-width: 120px;
          }
        }
      }
    }
  }
}
</style>
